import { render, staticRenderFns } from "./SvgButton.vue?vue&type=template&id=24dad9b8&scoped=true&"
import script from "./SvgButton.vue?vue&type=script&lang=js&"
export * from "./SvgButton.vue?vue&type=script&lang=js&"
import style0 from "./SvgButton.vue?vue&type=style&index=0&id=24dad9b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dad9b8",
  null
  
)

export default component.exports